import React, { useState } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";

import GenreContainer from "../../Containers/GenreContainer";
import EndlessScrollGenreTracksContainer from "./Containers/EndlessScrollGenreTracksContainer";
import ChimneyName from "../../Components/Elements/ChimneyName";
import Kba from "../../Components/Elements/Kba";
import TrackBoxCounter from "../../Components/Elements/TrackBoxCounter";
import JukeboxPlayGenre from "./JukeboxPlayGenre";
import GenreAddFavorite from "./GenreAddFavorite";
import BackToTop from "../../Components/Elements/BackToTop";
import { useUser } from "~/Context/userContext";

import "./GenrePage.less";

const GenrePage = ({ match }) => {
  const { state: userState } = useUser();
  const [trackCount, setTrackCount] = useState(0);

  return (
    <div className="genre-page-component">
      <GenreContainer
        genreId={match?.params?.genreId}
        render={({ genre, genrePopular, loading }) => (
          <React.Fragment>
            <Helmet>
              <title>{genre.name} | Dream Chimney</title>
              <link rel="canonical" href={`https://www.dreamchimney.com/tracks/genre/${match.params.genreId}`} />
            </Helmet>
            <Row>
              <Col xs={12}>
                <div className="totd-header">
                  <h1>
                    {genre.name} {genre.total >= 5 && <FontAwesomeIcon icon="trophy" className="trophy" />}
                  </h1>
                  <h4 className="rank">
                    <FontAwesomeIcon icon="signal" className="signal" /> Rank #{genre.rank} &nbsp; ({genre.total} Track
                    {genre.total !== 1 ? `s` : null})
                  </h4>
                </div>
              </Col>
            </Row>
            <Row className="genre-stats">
              <Col xs={12} sm={6} lg={8}>
                <Col xs={12}>
                  {/* <h4 className="totd-tabs">Most Popular Track</h4> */}
                  <div>
                    {genrePopular.map((t) => (
                      <div key={t.id}>
                        <strong>Most Popular Track:</strong> &ldquo;<Link to={`/${t.id}`}>{t.title}</Link>&rdquo; by {t.artist}
                      </div>
                    ))}
                  </div>
                </Col>
                <Col xs={12}>
                  {/* <h4 className="totd-tabs"></h4> */}
                  <div>
                    <div>
                      <strong>Genre Master{Object.keys(genre.master.chims).length > 1 ? "s" : null}:</strong>{" "}
                      {Object.keys(genre.master.chims).map((i) => (
                        <span key={i}>
                          <ChimneyName user={genre.master.chims[i]} /> {` `}
                          {/* [{genre.master.total} tracks] */}
                        </span>
                      ))}
                    </div>
                  </div>
                </Col>
                <Col xs={12}>
                  {/* <h4 className="totd-tabs">Genre Created By</h4> */}
                  <div>
                    <strong>Genre Created:</strong>
                    {` `}
                    {genre.created_by.date} by <ChimneyName user={genre.created_by.chim} />
                  </div>
                </Col>
                <Col xs={12}>
                  <GenreAddFavorite genreId={genre.id} />
                </Col>
              </Col>
              <Col xs={12} sm={6} lg={4}>
                {/* <TrackBoxCounter count={genre.total} /> */}
                <JukeboxPlayGenre className="hide-mobile" genreId={genre.id} />
              </Col>
            </Row>
            <Row className="divider"></Row>
            <EndlessScrollGenreTracksContainer
              filter={match.params.genreId}
              loading={loading}
              onItemsChange={setTrackCount}
            />
            <BackToTop show={trackCount >= 30} />
            <Kba />
            <span className="edit">
              {userState.user && userState.user.dir === "ryan" ? (
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`//www.dreamchimney.com/internal/promo-tracks/genre_recap.php?genreId=${genre.id}`}
                >
                  Share Genre
                </a>
              ) : null}
            </span>
          </React.Fragment>
        )}
      />
    </div>
  );
};

export default GenrePage;
